module.exports = __webpack_public_path__ + "img/f95570d.jpg";